import React from "react";
import ScorecardSummaryTableStickyHolesHeaderRow from "./ScorecardSummaryTableStickyHolesHeaderRow";
import "./ScorecardSummaryTableSticky.css"; // Import the CSS file

function ScorecardSummaryTableStickyHeader({
  throwScoringModeId,
  maxHole,
  managePage,
}) {
  //array to store integers
  let holes = [];
  for (let i = 0; i < maxHole; i++) {
    holes.push(i + 1);
  }
  return (
    <tr className="sticky">
      <th className="sticky" style={{ backgroundColor: "#5B107E" }}></th>

      {holes.map((hole, index) => {
        return (
          <ScorecardSummaryTableStickyHolesHeaderRow
            hole={hole}
            index={index}
            key={index}
            maxHole={maxHole}
          />
        );
      })}
      <th className="scorecard-summary-header-needs-left-border">Total</th>
      {managePage && <th>Total</th>}
      {throwScoringModeId > 1 && <th>Total+</th>}
    </tr>
  );
}

export default ScorecardSummaryTableStickyHeader;
